import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../store/authSlice";

function ConditionalRedirect() {
  const userData = useSelector(selectUser);

  // 如果 account_id === 2，重定向到首頁，否則重定向到 realtime
  const redirectTo = userData?.account_id === 1 ? "/realtime" : "/home";

  return <Navigate to={redirectTo} replace />;
}

export default ConditionalRedirect;